import lfRequest from '@/service/index'

export function queryStatistics(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/materialStatistics/queryStatistics',
    params: queryInfo
  })
}
